import React from 'react'
import MITSUBISHIac from "../images/MITSUBISHI ELECTRIC AC Slider.jpg";
import toshibaac from "../images/Tosiba ac.jpg";
import carriercentralizesac from "../images/carrier ac slider.jpg";
import daikin from "../images/daikin Ac Banner update.jpg"
import daikin_ac from "../images/Daikin Banner.jpg";


function Slider() {
  return (
    <div>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>

    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>

  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={daikin} className="d-block w-100" alt="daikin Krishnanagar"/>
    </div>
     <div className="carousel-item">
      <img src={daikin_ac} className="d-block w-100" alt="daikin_ac_krishnanagar"/>
    </div>
     <div className="carousel-item">
      <img src={toshibaac} className="d-block w-100" alt="MITSUBISHIac_krishnanagar"/>
    </div>
    <div className="carousel-item">
      <img src={MITSUBISHIac} className="d-block w-100" alt="MITSUBISHIac_krishnagar"/>
    </div>
    <div className="carousel-item">
      <img src={carriercentralizesac} className="d-block w-100" alt="carrierac krishnagar"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
        </div>
  )
}

export default Slider